import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

import * as cityActions from '../actions/index'; // Importing from index.ts
import { CitiesService } from '../../services/cities.service';


@Injectable()
export class CitiesEffects {
  constructor(
    private actions$: Actions,
    private citiesService: CitiesService
  ) {}

  getCities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cityActions.getCities),
      switchMap((action) =>
        this.citiesService.getCities(action.category).pipe(
          map((response) =>
            cityActions.getCitiesSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(cityActions.getCitiesFailure({ error }))
          )
        )
      )
    )
  );
}
